export default __webpack_public_path__ + "static/media/logout_icon.b3a1e2ec.svg";